var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch",value:(_vm.onClick),expression:"onClick"}],class:_vm.$style.wrapper,attrs:{"role":"button","data-name":"ui-button-wrapper"},on:{"click":_vm.onClick}},[_c('span',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c01f43","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiButton.vue
// module id = null
// module chunks = 